import api from '../../api/api-list'

const actions = {
  // 获取主讲人账户信息
  getChatroomPresenterAccount: ({ rootState, state, commit, dispatch}, props={}) => {
    let { currChatroom } = rootState.nim
    currChatroom.getChatroomMembersInfo({
      accounts: [state.liveDetailData.account_token],
      done: (error, obj)=>{
        if(!error){
          let members = obj.members.map(item=> {
            item.custom = item.custom ? JSON.parse(item.custom) : {}
            return item
          })
          console.log(members)
          commit('updateLiveState', {
            type: 'chatroomPresenterAccount',
            value: members
          })
        }
      }
    });
  },
  // 获取管理员账户信息
  getChatroomAdminAccount: ({ rootState, state, commit, dispatch}, props={}) => {
    let { currChatroom } = rootState.nim
    currChatroom.getChatroomMembersInfo({
      accounts: state.liveDetailData.admin_tokens,
      done: (error, obj)=>{
        if(!error){
          let members = obj.members.map(item=> {
            item.custom = item.custom ? JSON.parse(item.custom) : {}
            return item
          })
          console.log(members)
          commit('updateLiveState', {
            type: 'chatroomAdminAccount',
            value: members
          })
        }
      }
    });
  },
  // 获取普通账户信息
  getChatroomOrdinaryAccount: ({ rootState, state, commit, dispatch}, props={}) => {
    let { currChatroom } = rootState.nim
    let query = {
      guest: false, //true表示获取游客, false表示获取非游客成员
      limit: 3,
    }
    if(state.chatroomOrdinaryAccount.length){
      query.time = state.chatroomOrdinaryAccount[state.chatroomOrdinaryAccount.length-1].updateTime
    }
    console.log(query)
    currChatroom.getChatroomMembers({
      ...query,
      done: (error, obj)=>{
        console.log(error, obj)
        if(!error){
          let members = obj.members.map(item=> {
            item.custom = item.custom ? JSON.parse(item.custom) : {}
            return item
          })
          // members = members.filter(item=> item.type === 'common')
          commit('updateLiveState', {
            type: 'chatroomOrdinaryAccount',
            value: [...state.chatroomOrdinaryAccount, ...members]
          })
          // 如果数据相同，继续拉取
          if(obj.members.length === query.limit){
            setTimeout(() => {
              dispatch('getChatroomOrdinaryAccount')
            }, 5000);
          }
        }
      }
    });
  },

  /**
   * 方法名后加 ActionsFun 后缀，说明是 actions 里的方法，便于区分识别
   */
  // 获取 RTC token（观众）
  getRtcTokenActionsFun: async ({state, commit}) => {
    try {
      const { options } = state
      let token = null
      let params = {
        channel_name: options.channel,
        uid: options.uid,
        type: 'cv'
      }
      let res = await api.live.getRtcToken(params)
      if (res.code === 1000) {
        token = res.data
        commit('updateTokenState', token)
      }
      return token
    } catch (e) {
      console.log('获取 RTC token 错误：', e)
    }

  }
  
}

export default actions
